import { render, staticRenderFns } from "./voteMenu.vue?vue&type=template&id=b841d090&scoped=true&"
import script from "./voteMenu.vue?vue&type=script&lang=js&"
export * from "./voteMenu.vue?vue&type=script&lang=js&"
import style0 from "./voteMenu.vue?vue&type=style&index=0&id=b841d090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b841d090",
  null
  
)

export default component.exports